import {
    Box,
    Flex,
    Text,
    Image,
    Badge,
} from "@chakra-ui/react";

import {
    ArrowLeft,
} from "lucide-react";

import {
    useLocation,
    useNavigate,
} from "react-router-dom";

import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/Topbar";

import FAQSupportCard from "../FAQ/components/FAQSupportCard";

import SupportTicketModal from "../Support/components/SupportTicketModal";

import {
    useState,
} from "react";

const HelpTopicDetails = () => {
    const navigate =
        useNavigate();

    const {
        state,
    } = useLocation();

    const topic =
        state?.topic;

    const [
        open,
        setOpen,
    ] = useState(false);
    const renderDescription = (text) => {
    if (!text) return null;

    return text
        .split(/\r?\n\r?\n/)
        .filter(Boolean)
        .map((paragraph, index) => (
            <Text
                key={index}
                color="gray.700"
                lineHeight="2"
                mb={5}
                fontSize="md"
            >
                {paragraph.trim()}
            </Text>
        ));
};

    return (
       <Flex
    h="100vh"
    bg="#F8FAFC"
    overflow="hidden"
    marginBottom={{
        base: 20,
        md: 0,
    }}
>
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <Text
                        display="flex"
                        alignItems="center"
                        gap={2}
                        cursor="pointer"
                        color="#2453FF"
                        mb={6}
                        onClick={() =>
                            navigate(-1)
                        }
                    >
                        <ArrowLeft
                            size={18}
                        />
                        Back
                    </Text>

                    <Image
                        src={
                            topic.image
                        }
                        w="100%"
                        h="350px"
                        objectFit="cover"
                        borderRadius="20px"
                        mb={8}
                    />

                    <Badge
                        colorPalette="blue"
                        mb={4}
                    >
                        {
                            topic.category
                        }
                    </Badge>

                    <Text
                        fontSize="4xl"
                        fontWeight="700"
                        color="#071D54"
                        mb={4}
                    >
                        {
                            topic.title
                        }
                    </Text>

                       <Text
                        color="gray.500"
                        mb={8}
                    >
                        Updated{" "}
                        {new Date(
                            topic.updated_at
                        ).toLocaleDateString(
                            "en-BW",
                            {
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                            }
                        )}
                    </Text>

                   <Box mt={6}>
                        {renderDescription(topic.description)}
                   </Box>

                    <FAQSupportCard
                        onOpen={() =>
                            setOpen(
                                true
                            )
                        }
                    />
                </Box>
            </Flex>

            <SupportTicketModal
                isOpen={open}
                onClose={() =>
                    setOpen(
                        false
                    )
                }
            />
        </Flex>
    );
};

export default HelpTopicDetails;